import React, { useReducer } from 'react'
import {
  Popup,
  ButtonContainer,
  Button
} from 'camino-react'

import TicketStatusFields from '../../Tickets/Correspondence/Form/TicketStatus'

const TicketStatusExtraFields = ({
  displayStatusExtraFields,
  statusTicketId,
  updateDispatcherState,
  updateTicketStatus,
  selectedStatus
}) => {
  const initialState = {
    reopenOn: null,
    onHoldDescription: null,
    rootCause: null,
    preventiveAction: null,
    correctiveAction: null
  }

  const [statusFields, setStatusFields] = useReducer((prev, next) => ({ ...prev, ...next }), initialState)

  const {
    reopenOn,
    onHoldDescription,
    rootCause,
    preventiveAction,
    correctiveAction
  } = statusFields

  return (
    <Popup
      modal
      open={displayStatusExtraFields}
      onClose={() => updateDispatcherState({ displayStatusExtraFields: false, statusTicketId: null })}
    >
      <div>
        <div className="popup-content--header">
          Update Ticket #
          {statusTicketId}
        </div>
        <div className="popup-content--text">
          <TicketStatusFields
            disableTicketStatusSelect
            onValue={(field, value) => setStatusFields({ [field]: value })}
            selectedTicketStatusIs={value => value === selectedStatus}
            {...{
              reopenOn, onHoldDescription, rootCause, preventiveAction, correctiveAction
            }}
          />
        </div>
        <ButtonContainer center spaced>
          <Button outline onClick={() => updateDispatcherState({ displayStatusExtraFields: false, statusTicketId: null })}>
            Cancel
          </Button>
          <Button onClick={() => { updateTicketStatus(statusFields); setStatusFields(initialState) }}>
            Update
          </Button>
        </ButtonContainer>
      </div>
    </Popup>
  )
}

export default TicketStatusExtraFields
